<div class="grid-results">
  <div class="results-grid" *ngIf="searchState?.results && searchState.results.length > 0">
    <app-search-result-card
      *ngFor="let item of results$ | async; trackBy: trackByItem; index as i"
      [index]="i"
      [item]="item"
      [imageHeight]="364"
      [imageWidth]="364"
      [viewPortSize]="this.parentSize"
      (fitToItem)="onFitToItem($event)"
      (feedbackChange)="onFeedback($event, i + 1)"></app-search-result-card>
  </div>

  <!-- Infinite Scroll Info Panel -->
  <div
    class="state-container state-container--compact"
    *ngIf="searchState?.hasMore && !searchState?.loading && !searchState?.error"
    appIntersectObserver
    (appIntersect)="onInfiniteScroll()">
    <p class="state-description">Loading more...</p>
  </div>
  <div class="state-container state-container--compact" *ngIf="searchState?.loading">
    <mat-spinner diameter="40" class="mb-4"></mat-spinner>
    <p class="state-description">Loading results...</p>
  </div>
  <!-- Loading in Sidebar -->
  <div class="state-container state-container--compact" *ngIf="searchState?.error">
    <mat-icon class="landing-icon" [class]="SearchUtilsService.getErrorIconClass(searchState.errorType)">
      {{ SearchUtilsService.getErrorIcon(searchState.errorType) }}
    </mat-icon>
    <h3 class="state-title">{{ SearchUtilsService.getErrorTitle(searchState.errorType) }}</h3>
  </div>
</div>
